import { apiRequest } from "../utils/api";

const MATCH_VALUE_MAX_LENGTH = 500;

// Drops entries the backend would reject (empty/oversized value) instead of
// letting them round-trip to a 400 - see pii-update-brief.md.
const sanitizeMatches = matches =>
  (matches || []).filter(
    match => typeof match?.value === "string" && match.value.length > 0 && match.value.length <= MATCH_VALUE_MAX_LENGTH
  );

/**
 * Logs a PII/sensitive-data flag event. `detectionTypes` is metadata only.
 * `matches` (optional) carries the raw value for a subset of high-confidence
 * detection types so it can be encrypted and stored server-side - see
 * pii-update-brief.md and pii-detection-api-spec.md for the backend contract
 * (log-once-per-session enforcement lives server-side).
 */
const logPiiFlag = async ({
  sessionId,
  stage,
  fieldReference,
  detectionTypes,
  overridden = false,
  overrideReason = null,
  matches,
}) => {
  const sanitizedMatches = matches ? sanitizeMatches(matches) : undefined;
  try {
    const response = await apiRequest.post(
      "/api/pii-detection-logs",
      {
        sessionId,
        stage,
        fieldReference,
        detectionTypes,
        overridden,
        overrideReason,
        matches: sanitizedMatches,
        timestamp: new Date().toISOString(),
      },
      { showLoader: false, skipNotification: true }
    );
    return response.data;
  } catch (err) {
    // Logging must never block or visibly disrupt the coaching workflow,
    // e.g. while the backend endpoint doesn't exist yet.
    console.warn("Failed to log PII flag:", err.message);
    return null;
  }
};

export default {
  logPiiFlag,
};
